<template>
  <Tooltip text="Customer Support & Assistant">
    <v-btn @click="OpenHelpWindow" class="mr-2" icon="mdi-help-circle-outline" />
  </Tooltip>
</template>

<script setup lang="ts">
import Tooltip from "@/components/misc/Tooltip.vue"
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()

function OpenHelpWindow() {
  store.OpenHelpWindow()
}
</script>
